import {includes, replace} from 'lodash'
import Network from '@/services/network'
import {ref} from 'vue'
import useDate from '@/services/utils/day'
import figureFormatter from '@/services/utils/figureFormatter.js'

const {
    firstDateOfQuarter,
    lastDateOfQuarter,
    lastDateOfYear,
    firstDateOfYear,
    firstDateOfLastYear,
    lastDateOfLastYear,
    firstDateOfMonth,
    lastDateOfMonth,
    firstDateOfLastMonth,
    lastDateOfLastMonth
} = useDate()

const network = new Network

export function useCardStatistics(params) {
    const statisticsItem = ref({});
    const {commaFormat} = figureFormatter()

    const makeStatistics = (statisticsData, notIncludeArr) => {
        let statistics = []
        Object.keys(statisticsData).forEach((key) => {
            if (!includes(notIncludeArr, key)) {
                statistics.push(
                    {
                        name: replace(key, /[\_]/g, ' '),
                        value: commaFormat(statisticsData[key]),
                        key: key
                    }
                )
            }
        })
        return statistics
    }

    function getDashboardData(query = '') {
        network.api('get', `/get/dashboard?company_id=${params.companyId}&module_id=${params.moduleId}` + query)
            .then(res => {
                if (res.status) {
                    statisticsItem.value = res.data
                }
            })
    }

    //`"start":"","end":""`
    const timeRange = [
      {
        name: 'This Month',
        value: {
          start: firstDateOfMonth,
          end: lastDateOfMonth
        }
      },
      {
        name: 'Last Month',
        value: {
          start: firstDateOfLastMonth,
          end: lastDateOfLastMonth
        }
      },
      {
        name: 'This Quarter',
        value: {
          start: firstDateOfQuarter,
          end: lastDateOfQuarter
        }
      },
      {
        name: 'This Year',
        value: {
          start: firstDateOfYear,
          end: lastDateOfYear
        }
      },
      {
        name: 'Last Year',
        value: {
          start: firstDateOfLastYear,
          end: lastDateOfLastYear
        }
      }
    ];

    return {
        makeStatistics,
        timeRange,
        getDashboardData,
        statisticsItem,
    }
}
